import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from '../';

export interface IAuditFieldLog {
    id: number,
    tableName: string,
    entityId: number,
    columnName: string,
    beforeValue: string,
    afterValue: string,
    changeDateTime: string,
    userId: number,
    userFullName: string,
    reason: string,
    action: number
}

export interface IGetActivityLogResponse {
    data: {
        success: boolean,
        results: IAuditFieldLog[]
    }
}

export interface IActivityLogFilters {
    tableName?: string,
    fromDate?: string,
    toDate?: string
}

export interface IActivityLogTrackedField {
    propertyName: string,
    columnLabel: string,
    isBool: boolean
}

export interface IGetTrackedFieldsResponse {
    data: {
        success: boolean,
        results: IActivityLogTrackedField[]
    }
}

export const ActivityLogActionCreators = {
    getActivityLog: (centerId: number, filters: IActivityLogFilters = {}) => async (dispatch: Dispatch<IApplicationState>): Promise<IGetActivityLogResponse> => {
        const params = new URLSearchParams();
        if (filters.tableName) params.append('tableName', filters.tableName);
        if (filters.fromDate) params.append('fromDate', filters.fromDate);
        if (filters.toDate) params.append('toDate', filters.toDate);

        const query = params.toString() ? `?${params.toString()}` : '';
        const options = { url: `${__API__}/center/${centerId}/activity-log${query}` };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getActivityLogTrackedFields: () => async (dispatch: Dispatch<IApplicationState>): Promise<IGetTrackedFieldsResponse> => {
        const options = { url: `${__API__}/center/activity-log/tracked-fields` };
        return await dispatch(AuthActionCreators.apiGet(options));
    }
};
